import * as React from 'react';
import LayersContext from './LayersContext';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const style = {
  isolation: 'isolate'
};
function Layers(props) {
  const rootRef = React.useRef(null);
  const overlaysRef = React.useRef(null);
  const messagesRef = React.useRef(null);
  const [state, setState] = React.useState();
  React.useEffect(() => {
    setState({
      root: rootRef.current,
      overlays: overlaysRef.current,
      messages: messagesRef.current
    });
  }, []);
  return /*#__PURE__*/_jsxs(LayersContext.Provider, {
    value: state,
    children: [/*#__PURE__*/_jsx("div", {
      ref: rootRef,
      style: style,
      children: props.children
    }), /*#__PURE__*/_jsx("div", {
      ref: overlaysRef,
      style: style
    }), /*#__PURE__*/_jsx("div", {
      ref: messagesRef,
      style: style
    })]
  });
}
export default Layers;